import { Chat } from '@tunasong/plugin-chat/ui'
import type { SidebarComponent } from '@tunasong/ui-lib'
import type { FC } from 'react'
import { PanelEmptyState } from './panel-empty-state.js'

export const SidebarChat: FC<SidebarComponent> = ({ entity }) => (
  <Chat
    element={entity}
    showTabs={false}
    emptyState={<PanelEmptyState title="No open comments" body="Select a line in the song to start a thread." />}
  />
)
